<template>
	<div class="w-full rounded documentCard">
		<div class="flex bg-white">
			<div class="tab active">{{ $t('documents') }} {{ $t('administrate') }}</div>
		</div>

		<div>
			<DamageAssessorCaseDocumentUploadTab
				:damage-assessor-case="damageAssessorCase"
				:is-editable="isEditable"
				:active-tab="activeTab"
				@changeDocumentTab="$emit('changeDocumentTab', $event)"
				@updated="$emit('updated')"
			/>
		</div>
	</div>
</template>

<script>
import DamageAssessorCaseDocumentUploadTab from '@/components/damageassessorcases/documents/DamageAssessorCaseDocumentUploadTab.vue';

export default {
	name: 'DamageAssessorCaseDocuments',

	components: {
		DamageAssessorCaseDocumentUploadTab,
	},

	props: {
		damageAssessorCase: {
			type: Object,
			required: true,
		},

		isEditable: {
			type: Boolean,
			default: true,
		},

		activeTab: {
			type: String,
			default: 'customer',
		},
	},
};
</script>

<style scoped>
.tab {
	@apply text-gray-500 bg-gray-200 font-bold cursor-pointer px-5 py-6 leading-none rounded border-t border-r border-l box-border;
	font-size: 18px;
}

.tab.active {
	@apply text-connectProBlue bg-black border-transparent;
	--bg-opacity: 0.04;
}

.documentCard {
	@apply bg-black;
	--bg-opacity: 0.04;
}
</style>
